import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import heloicon from '../../../safreeimg/superadminimg/heloicon.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import edit from '../../../safreeimg/edit.png';
import addbtn from '../../../safreeimg/addbtn.png';
import Loader from '../../../safreeimg/loader.gif';
import { Link } from "react-router-dom";


const OrganisationManagement = () => {
  const [organisations, setOrganisations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [selectedExtensions, setSelectedExtensions] = useState({});
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    name: '',
    address: '',
    phoneNumber: '',
    image: null,
  });
  const [editData, setEditData] = useState(null);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showPopup, setShowPopup] = useState(false); // State for popup visibility
  const [selectedOrgId, setSelectedOrgId] = useState(null); // To track selected organization

  const rowsPerPage = 10;
  const navigate = useNavigate();

  const fetchOrganisations = async () => {
    
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');
      if (!token) {
        setError('No token found');
        setLoading(false);
        return;
      }

      const response = await axios.get('https://api.safree.org/api-v2022/superAdmin/auth/v1/allOrganizations', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setOrganisations(response.data.data);
    } catch (err) {
      setError('Error fetching data: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganisations();
  }, []);

  const totalPages = Math.ceil(organisations.length / rowsPerPage);
  const currentRows = organisations.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append('email', formData.email);
    form.append('password', formData.password);
    form.append('name', formData.name);
    form.append('address', formData.address);
    form.append('phoneNumber', formData.phoneNumber);
    form.append('image', formData.image);

    try {
      setIsSubmitting(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://api.safree.org/api-v2022/superAdmin/auth/v1/registerOrganization',
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      alert('Organization successfully added!');
      setShowForm(false);
      await fetchOrganisations();
    } catch (err) {
      alert('Error adding organization: ' + err.message);
    }finally {
      setIsSubmitting(false); // Stop loading after request finishes
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append('name', editData.name);
    form.append('orgId', editData.orgId);
    form.append('email', editData.email);
    form.append('address', editData.address);
    form.append('phoneNumber', editData.phoneNumber);
    form.append('password', editData.password);
    if (editData.image) {
      form.append('image', editData.image);
    }

    try {
      setIsSubmitting(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `https://api.safree.org/api-v2022/superAdmin/auth/v1/edit/organization`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        alert('Organization successfully updated!');
        setShowEditForm(false);
        await fetchOrganisations();
      } else {
        alert('Failed to update the organization');
      }
    } catch (err) {
      alert('Error updating organization: ' + err.message);
    }finally {
      setIsSubmitting(false); // Stop loading after request finishes
    }
  };

  const handleExtensionChange = (orgId, value, type = 'extension') => {
    setSelectedExtensions((prev) => ({
      ...prev,
      [orgId]: {
        ...prev[orgId],
        [type]: value,
      },
    }));
  };

  const handlePopupOpen = (orgId) => {
    setSelectedOrgId(orgId);
    setShowPopup(true);
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  const handleSubscriptionSubmit = async () => {
    const { extension, number } = selectedExtensions[selectedOrgId] || {};

    if (!extension || !number) {
      alert('Please select both duration and number of users');
      return;
    }

    const form = new FormData();
    form.append('organizationId', selectedOrgId);
    form.append('duration', extension);
    form.append('memberCount', number);

    try {
      setIsSubmitting(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://api.safree.org/api-v2022/superAdmin/auth/v1/update/organization/subscription',
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        alert('Subscription updated successfully!');
        setShowPopup(false); // Hide the popup after submission
        await fetchOrganisations();
      } else {
        alert('Failed to update subscription');
      }
    } catch (err) {
      alert('Error updating subscription: ' + err.message);
    }finally {
      setIsSubmitting(false); // Stop loading after request finishes
    }
  };

  const handleCancelSubscription = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!selectedOrgId) {
        alert('No organization selected!');
        return;
      }

      const form = new FormData();
      form.append('organizationId', selectedOrgId);

      // Call the API to cancel the subscription
      const response = await axios.post(
        'https://api.safree.org/api-v2022/SuperAdmin/auth/v1/cancel/org/subscription',
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 200) {
        alert('Subscription canceled successfully!');
        setShowPopup(false); // Close the popup
        await fetchOrganisations(); // Refresh the list of organizations
      } else {
        alert('Failed to cancel the subscription');
      }
    } catch (err) {
      alert('Error canceling subscription: ' + err.message);
    }
  };



  if (loading) return <div className='loading'><img src={Loader} alt="" /></div>;

  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management popchange">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Organization Management</p>
        </div>
        <div className="col-md-6 hedrcol2">
          <h3 onClick={() => setShowForm(true)} style={{ cursor: 'pointer' }}>
            Add New Organization <img src={addbtn} alt="" />
          </h3>
           <Link to="/admin1/organisation-Management/CouponDiscountOrg"><button className="condisp">Coupon & Discount</button></Link>
        </div>
      </div>

      <div className="content-wrapper">
        <div className="table-container tbcon">
          <table className="styled-table">
            <thead>
              <tr>
                <th>S. No</th>
                <th>Organisation Name</th>
                <th>Email ID</th>
                <th>Address</th>
                <th>Phone No</th>
                <th>Logo</th>
                <th>Member Details</th>
                <th>Organization Groups</th>
                <th style={{ padding: '1px 50px' }}>Plan Expiry</th>
                <th>Subscription</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((organisation, index) => (
                <tr key={organisation.orgId}>
                  <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                  <td>{organisation.name}</td>
                  <td>{organisation.email}</td>
                  <td>{organisation.address}</td>
                  <td>{organisation.phoneNumber}</td>
                  <td>
                    {organisation.logo ? (
                      <img
                        src={organisation.logo}
                        alt="Organisation Logo"
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                      />
                    ) : (
                      <span>No Logo Available</span>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-view"
                      onClick={() => navigate(`../organisation-Management/organisationMember/#${organisation.orgId}`)}
                    >
                      View
                    </button>
                  </td>
                  <td>
                    <button
                      className="btn btn-view"
                      onClick={() => navigate(`../organisation-Management/organizationGroup/#${organisation.orgId}`)}
                    >
                      View
                    </button>
                  </td>
                  <td>{organisation.subscriptionExpiryDate}</td>
                  <td>
                    {organisation.currentPlan}
                    <button
                      onClick={() => handlePopupOpen(organisation.orgId)}
                      className='plnxtend'>
                      Update
                    </button>
                  </td>

                  <td className="edits">
                    <button
                      className="btn btn-view"
                      onClick={() => setEditData(organisation) || setShowEditForm(true)}
                    >
                      <img src={edit} alt="" />Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


          <div className="pagination-container">
            <button
              className="pagination-btn"
              onClick={() => handlePageChange('prev')}
              disabled={currentPage === 1}
            >
              &laquo; Prev
            </button>
            {Array.from({ length: totalPages }, (_, index) => (
              <button
                key={index}
                className={`pagination-btn ${currentPage === index + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </button>
            ))}
            <button
              className="pagination-btn"
              onClick={() => handlePageChange('next')}
              disabled={currentPage === totalPages}
            >
              Next &raquo;
            </button>
          </div>
        </div>
      </div>
      <div className={`side-form ${showForm ? 'show' : ''}`}>
        <h3>Add Organisation</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Organisation Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email ID"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={formData.phoneNumber}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleInputChange}
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleInputChange}
            required
          />
          <input
            type="file"
            name="image"
            onChange={handleFileChange}
            required
          />
          <button type="submit" className="btn-save">
          {isSubmitting ? (
                  <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
                  </div>
                ) : (
                  'Save Details'
                )}
          </button>
          <button type="button" className="btn-cancel" onClick={() => setShowForm(false)}>Cancel</button>
        </form>
      </div>

      <div className={`side-form ${showEditForm ? 'show' : ''}`}>
        <h3>Edit Organisation</h3>
        <form onSubmit={handleEditSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Organisation Name"
            value={editData?.name || ''}
            onChange={(e) =>
              setEditData({ ...editData, name: e.target.value })
            }
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Email ID"
            value={editData?.email || ''}
            onChange={(e) =>
              setEditData({ ...editData, email: e.target.value })
            }
            required
          />
          <input
            type="address"
            name="address"
            placeholder="address"
            value={editData?.address || ''}
            onChange={(e) =>
              setEditData({ ...editData, address: e.target.value })
            }
            required
          />
          <input
            type="text"
            name="phoneNumber"
            placeholder="Phone Number"
            value={editData?.phoneNumber || ''}
            onChange={(e) =>
              setEditData({ ...editData, phoneNumber: e.target.value })
            }
            required
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={editData?.password || ''}
            onChange={(e) =>
              setEditData({ ...editData, password: e.target.value })
            }

          />
          <input
            type="file"
            name="image"
            onChange={(e) =>
              setEditData({ ...editData, image: e.target.files[0] })
            }
          />
          <button type="submit" className="btn-save">
          {isSubmitting ? (
                  <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
                  </div>
                ) : (
                  'Update'
                )}
            </button>
          <button type="button" className="btn-cancel" onClick={() => setShowEditForm(false)}>Cancel</button>
        </form>
      </div>
      {/* Popup for Subscription form */}
      {/* Popup for Subscription form */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <h3>Update Subscription</h3>
            <button onClick={handlePopupClose} className="close-btn">X</button>
            <select
              value={selectedExtensions[selectedOrgId]?.extension || ""}
              onChange={(e) =>
                handleExtensionChange(selectedOrgId, e.target.value, "extension")
              }
            >
              {/* <option value="">
                {organisations.find((o) => o.orgId === selectedOrgId)?.currentPlan}
              </option> */}
              <option value="1 Month">Select Duration</option>
              <option value="1 Month">1 Month</option>
              <option value="3 Months">3 Months</option>
              <option value="6 Months">6 Months</option>
              <option value="1 Year">1 Year</option>
            </select>

            <select
              value={selectedExtensions[selectedOrgId]?.number || ""}
              onChange={(e) =>
                handleExtensionChange(selectedOrgId, e.target.value, "number")
              }
            >
              <option value="">Select Users</option>
              {[...Array(2000).keys()].map((i) => {
                const number = (i + 1) * 5;
                return (
                  <option key={number} value={number}>
                    {number} {number === 1 ? "User" : "Users"}
                  </option>
                );
              })}
            </select>
            <button onClick={handleSubscriptionSubmit} className="plnxtend">
            {isSubmitting ? (
                  <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
                  </div>
                ) : (
                  'Submit'
                )}
              
            </button>

            {/* Cancel Plan Button */}
            {!showCancelConfirmation ? (
              <button
                onClick={() => setShowCancelConfirmation(true)}
                className="plnxtend"
              >
                Cancel Plan
              </button>
            ) : (
              <div className="cancel-confirmation-message">
                <p>
                  Are you sure you want to cancel the plan? This will disable all
                  access to users or the organization.
                </p>
                <button onClick={handleCancelSubscription} className="confirm-btn">
                  Yes
                </button>
                <button
                  onClick={() => setShowCancelConfirmation(false)}
                  className="cancel-btn"
                >
                  No
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrganisationManagement;
